export default {
    init() {
        window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        if (!window.SpeechRecognition) {
            return;
        }

        this.$button = $('.header-middle__search-voice-button');
        this.$input = $('.header-middle__search-input');

        if (this.$button.length === 0) {
            return;
        }

        this.$button.removeClass('d-none');
        this.$button.on('click', this.onClick.bind(this));

        this.recognition = new SpeechRecognition();
        this.recognition.interimResults = true;
        this.recognition.lang = 'ru-RU';
        this.recognition.addEventListener('result', this.onResult.bind(this));

        this.recognition.onerror = function(event) {
            console.log(event.error);

            if (event.error === 'no-speech') {
                this.$button.removeClass('active');
                this.$input.attr('placeholder', 'Поиск...');
            }
        }
    },

    onClick() {
        this.$input.attr('placeholder', 'Говорите...');
        this.recognition.start();
    },

    onResult(e) {
        const textResult = Array.from(e.results).map((result) => result[0]).map((result) => result.transcript).join('');

        this.$input.val(textResult);

        if (e.results[0].isFinal) {
            $('.header-middle__search-form').get(0).submit();
        }
    },
};